import { memo, useCallback, useState } from 'react'
import { useDrop } from 'react-dnd'
import { LocationCard } from './LocationCard.js'
import { DistanceComponent } from './distance'
import { TripLocation } from './Location';

const style = {
    width: '100%',
}

export const LocationContainer = ({ locations, distances, onChange }) => {
    //const [cards, setCards] = useState(locations)
    const findCard = useCallback(
        (id) => {
            const location = locations.filter((c) => `${c.sequence}` === `${id}`)[0]
            console.log('find card', id, locations, location);
            return {
                location,
                index: locations.indexOf(location),
            }
        },
        [locations],
    )
    const moveCard = useCallback(
        (id, atIndex) => {
            const { location, index } = findCard(id);
            let old = locations || [];
            let locs = [...old];
            console.log('move card', id, index, atIndex);
            locs.splice(index, 1);
            locs.splice(atIndex, 0, location);
            onChange(locs);
        },
        [findCard, locations],
    )

    const removeLocation = (i) => {
        console.log('remove location');
        let old = locations || [];
        let locs = [...old];
        locs.splice(i, 1);
        onChange(locs);
    }

    const setLocation = (l, i) => {
        console.log('modifying location');
        let old = locations || [];
        let locs = [...old];
        locs[i] = l;
        console.log('new array', locs);
        onChange(locs);
    }

    const getCachedDistance = (p1, p2) => {
        for (let i = 0; i < distances.length; i++) {
            let dist = distances[i];
            if ((dist.fromPlaceId == p1 && dist.toPlaceId == p2) ||
                (dist.fromPlaceId == p2 && dist.toPlaceId == p1)) {
                return dist;
            }
        }
        return null;
    }

    const [, drop] = useDrop(() => ({ accept: 'locationcard' }))
    return (<>
        <div ref={drop} style={style}>
            {locations.map((location, i) => {
                let dist = <></>;
                console.log('location', i, location.place_id, location.previous_place_id);
                if (i > 0 && location.place_id && location.previous_place_id) {
                    let d = getCachedDistance(location.place_id, location.previous_place_id);
                    if (d !== null) {
                        dist = <DistanceComponent distance={d}></DistanceComponent>;
                    }
                    console.log('location distance', i, d);
                }

                if (i == (locations.length - 1)) {
                    return <>
                        {dist}
                        <TripLocation
                            value={location}
                            onChange={(loc) => setLocation(loc)}
                            readonly={true}>
                        </TripLocation>
                    </>
                }
                else {
                    return <>
                        {dist}
                        <LocationCard
                            location={location}
                            index={i}
                            count={locations.length}
                            key={'locationCard.' + i}
                            last={(i == (locations.length - 1))}
                            onChange={(l) => setLocation(l, i)}
                            onRemove={() => removeLocation(i)}
                            moveCard={moveCard}
                            findCard={findCard}
                        />
                        </>
                }
            })}
        </div>
        </>
    )
}
